import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotificationsPreview } from '@/api/queries/notifications.queries';
import { ROUTES } from '@/routes/routes';

export const useNotificationDialog = (
  onClose: () => void,
  onCountUpdate?: (count: number) => void,
  onMarkAsRead?: () => void,
) => {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useNotificationsPreview(10);

  const notifications = data?.notificationsModelList || [];
  const totalCount = data?.totalCount || 0;

  // Update count when notifications change
  useEffect(() => {
    if (onCountUpdate) {
      onCountUpdate(totalCount);
    }
  }, [totalCount, onCountUpdate]);

  const handleViewAll = useCallback(() => {
    if (onMarkAsRead) {
      onMarkAsRead();
    }
    onClose();
    setTimeout(() => {
      navigate(ROUTES.notifications);
    }, 100);
  }, [onMarkAsRead, onClose, navigate]);

  return {
    notifications,
    totalCount,
    isLoading,
    isError,
    handleViewAll,
  };
};
